<template>
    <div class="hotShopWrap">
        <div v-if="listArr.length!=0">
            <div style="overflow: scroll;-webkit-overflow-scrolling: touch;" ref="wrapper" :style="{ height: (wrapperHeight) + 'px' }">
                <mt-loadmore :top-method="loadTop" :bottom-method="loadBottom" :bottom-all-loaded="allLoaded" ref="loadmore" :autoFill="isAutoFill">
                    <ul class="hotShop_list">
                        <li v-for="(val,ind) in listArr" :key="ind" @click="goDetail(val)">
                            <h3>
                                <span>{{val.districts}} | {{val.shop_area}}</span>
                                <span><b>{{val.money[0]}}</b>{{val.money[1]}}</span>
                            </h3>
                            <div class="hotShop_con">
                                <img :src="val.main_img+'@!middle.jpg'" alt="">
                                <span class="hot_flag" v-if="val.top==1">热门</span>
                                <span class="hot_flag new_flag" v-if="val.top==1&&val.lasted_shop==1" style="background:#de4b4f">新上</span>
                                <div class="hotShop_text" v-if="val.introduce">
                                    {{val.introduce}}
                                </div>
                            </div>
                        </li>
                    </ul>
                </mt-loadmore>
            </div>
        </div>
        <div class="noData" v-if="flag">
            <NoData></NoData>
        </div>
    </div>
</template>
<script>
import qs from "qs"
import { MessageBox } from 'mint-ui'
import { Indicator } from 'mint-ui';
import NoData from "@/components/noData.vue";

export default {
    data(){
        return{
            listArr: [], //数据
            page: 1, //当前页
            hasmore: null, //是否有下一页
            allLoaded:false,
            isAutoFill:false,
            wrapperHeight: 0,
            isRefresh: false,
            flag:false, 
            city: 1, //当前城市
        }
    },
    components: {
        NoData, //无数据
    },
    methods: {                                                                                                                                  
        // 获取数据
        getData(){
            var that = this
            that.ajax.get(that.globalData.serverSrc+'/app/shop/innertop?page'+that.page+'&city='+that.city).then(res=>{
                if(res.status == 200 && res.data.status == 1){
                    that.listArr = that.listArr.concat(res.data.data.list)
                    that.hasmore = res.data.data.hasmore
                    that.isRefresh = true
                    // 关闭弹窗
                    Indicator.close();
                    if(that.listArr.length == 0){
                        that.flag = true
                    }
                }else{
                    that.$toast({
                        message: res.data.note,
                        position: 'middle',
                        duration: 2000
                    })
                }
            })
        },
        // 上拉加载
        loadBottom: function(){
            if(this.hasmore == 1){
                this.page ++
                this.getData()
                Indicator.open({
                    text: '加载中...',
                    spinnerType: 'fading-circle'
                });
            }else{
                this.$toast({
                    message: '没有更多了~',
                    position: 'middle',
                    duration: 2000
                })
            }
            this.$refs.loadmore.onBottomLoaded();
        },
        // 下拉刷新
        loadTop() {
            this.page = 1
            this.listArr = []
            this.getData()
            if(this.isRefresh){
                this.$refs.loadmore.onTopLoaded();
                this.isRefresh = false
            }
        },
        // 跳转详情
        goDetail(val){
            var uagent=navigator.userAgent;
            var isLepu=false;
            // uagent = 'appType/app_h5_android_4.3.30'
            var uamatch=uagent.match(/appType\/app_h5_(.*)/);
            var app_str,app_info,app_info_len,isLepuAndroid,isLepuIos,lepuVersion;

            if(uamatch){
                isLepu=true;
                app_str=uamatch[1];

                app_info=app_str.split('_');
                app_info_len=app_info.length;
                if(app_info_len>0){
                    if(app_info.length==2){
                        if(app_info[0] == 'android'){
                            isLepuAndroid=true;
                        }else if(app_info[0] == 'ios'){
                            isLepuIos=true;
                        }
                        lepuVersion=app_info[1];

                    }else if(app_info.length==1){
                        if(app_info[0] == 'android'){
                            isLepuAndroid=true;
                        }else if(app_info[0] == 'ios'){
                            isLepuIos=true;
                        }

                    }
                }
                
            }
            if(isLepu){
                // var selected_shop_id = 1037838
                // if(selected_shop_id){
                    // var arg='{"act":"open_chat","id":"'+selected_shop_id+'","imuser":"'+val.to_user+'"}';
                // }else{ 
                    var arg='{"act":"huodong315","id":"'+val.id+'"}';
                // }
                // console.log(arg);

                if(localStorage.getItem('istype')=='android'){
                    android.postMessage(arg);
                }else{
                    window.webkit.messageHandlers.appRun.postMessage(arg)
                }
            }else{
                MessageBox({
                    message: '请在乐铺APP内查看',
                    confirmButtonText: '去下载',
                    callback:action=>{
                        location.href = '//m.lepu.cn/app/down'
                    }
                })
            }

            // location.href = '//m.lepu.cn/beijing/shop/detail?id='+val.id
        }
    },
    created(){
        if(JSON.stringify(this.$route.query) != '{}' && this.$route.query.city != 'undefined' && this.$route.query.city != undefined){
            this.city = this.$route.query.city
        }
        this.getData()
    },
    updated(){
        if(this.$refs.wrapper!=undefined){
            this.wrapperHeight = 
            document.documentElement.clientHeight -
            this.$refs.wrapper.getBoundingClientRect().top
        }
        return
    }
}
</script>
<style lang="scss" scoped>
.hotShopWrap{
    width: 100%;
    height: 100%;
    background: #fff;
}

.hotShop_list{
    width:100%;
    padding: 0 .2rem;
    box-sizing: border-box;

    li{
        width:100%;
        padding-bottom: .4rem;
        border-bottom: .01rem solid #eee;
        box-sizing: border-box;

        h3{
            width: 100%;
            height: .88rem;
            display:flex;
            justify-content: space-between;
            align-items: center;

            span{
                font-size: .26rem;
                color: #555;

                b{
                    font-size: .36rem;
                }

                &:nth-child(1){
                    width: 5rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                &:nth-child(2){
                    color: #e22222;
                    font-size: .22rem;
                }
            }
        }

        .hotShop_con{
            width: 100%;
            height: 3.5rem;
            border-radius: .1rem;
            position: relative;
            overflow: hidden;

            img{
                width: 100%;
                height: 100%;
            }

            .hot_flag{
                position: absolute;
                display: block;
                width: .76rem;
                height: .4rem;
                text-align: center;
                line-height: .4rem;
                background: #f1b74c;
                color: #fff;
                font-size: .22rem;
                top: 0;
                left: 0;
            }

            .new_flag{
                left: .9rem;
            }

            .hotShop_text{
                width: 100%;
                height: .76rem;
                padding: .06rem .2rem;
                box-sizing: border-box;
                line-height: .34rem;
                box-sizing: border-box;
                background:rgba(0,0,0,.5);
                position: absolute;
                left: 0;
                bottom: 0;
                color: #fff;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
                color: #dfdfdf;
            }
        }
    }
}

</style>